module.exports = __webpack_public_path__ + "static/img/207.986afd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200518/207.jpg
// module id = uHd3
// module chunks = 0